/**
 * DEAD SIGNAL — canonical knowledge plane read accessor.
 *
 * The single import surface for the JSON bibles under ./data/. Other lanes
 * import from here; nothing outside this module reads the raw JSON.
 *
 * Evidence lookup resolves three id forms:
 *   - canonical UPPER_SNAKE ids (D4): 'BATTERY_LANTERNS'
 *   - legacy scene codes:            'PE-001'
 *   - prior KB location codes:       'SE-01'
 *
 * EVIDENCE_REGISTRY (the legacy-shape map keyed by canonical id) is derived in
 * ../evidenceRegistry.js from allEvidence(); it is re-exported here so the full
 * read surface (getEvidence, allEvidence, EVIDENCE_REGISTRY, the named bibles)
 * is reachable from this one module. The derivation is not duplicated.
 */
// CLIENT BUNDLE SCOPE: the client never imports the full bibles, so full-game
// canon (story, character, chapter, scene, hint-ladder, puzzle, interference,
// hotspot-registry, npc-phase, and the full evidence bible) does not ship in
// dist. Those stay in ./data/ for the server (app/functions) and docs/eval
// tooling. The client gets:
//   - evidence: a DEMO-ONLY slice (data/evidence-demo.json, generated from the
//     bible by scripts/gen-evidence-demo.mjs and D5-projected to drop full-game
//     fields) feeding getEvidence / allEvidence / EVIDENCE_REGISTRY (locker, evals).
//   - interviewBible: contradictionDetector.js (config, no full-game canon).
//   - Craine chunk allowlists: spoiler-free ../crainePhaseAllowlists.js.
import evidenceDemo from './data/evidence-demo.json';
import interviewBible from './data/interview-bible.json';

const evidenceIndex = new Map();
for (const record of evidenceDemo.entries) {
  evidenceIndex.set(record.id, record);
  if (record.legacyId) evidenceIndex.set(record.legacyId, record);
  if (record.kbCode) evidenceIndex.set(record.kbCode, record);
}

/** Resolve a demo evidence record by canonical id, legacyId, or kbCode. */
export function getEvidence(id) {
  return evidenceIndex.get(id) || null;
}

/** Every demo evidence record, in slice order. */
export function allEvidence() {
  return evidenceDemo.entries;
}

export {
  interviewBible,
};

// Re-export the derived legacy-shape registry (defined in ../evidenceRegistry.js)
// so EVIDENCE_REGISTRY and getEvidence are both reachable from this module.
export { EVIDENCE_REGISTRY } from '../evidenceRegistry.js';
